// @flow
import React, { Component } from 'react';
import {
  TextArea, Checkbox, Radio, RadioGroup,
} from 'informed';

import { PrimaryText, SecondaryText } from '../../../Typography.jsx';
import ContentBox from '../../../ContentBox.jsx';

import styles from '../../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  musculoskeletal: Object,
}

class ViewMusculoskeletal extends Component<Props> {
  render() {
    const musculoskeletal = this.props.musculoskeletal || {};
    return (
      <ContentBox title='Musculoskeletal'>
        <div className={styles.col}>
          <PrimaryText>Range of Motion (ROM)</PrimaryText><br />
          <div className={styles.section}>
            <Checkbox disabled field='musculoskeletal.fullROM' initialValue={musculoskeletal.fullROM} />Moves all extremities with full range of motion<br />
          </div>
          <div className={styles.section}>
            <SecondaryText>Left arm:</SecondaryText><br />
            <RadioGroup field='musculoskeletal.leftArmROM' initialValue={musculoskeletal.leftArmROM}>
              <Radio disabled value='full rom' />Full ROM<br />
              <Radio disabled value='limited rom' />Limited ROM<br />
              <Radio disabled value='immobile' />Immobile<br />
              <Radio disabled value='flaccid' />Flaccid<br />
              <Radio disabled value='contractured' />Contractured
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Right arm:</SecondaryText><br />
            <RadioGroup field='musculoskeletal.rightArmROM' initialValue={musculoskeletal.rightArmROM}>
              <Radio disabled value='full rom' />Full ROM<br />
              <Radio disabled value='limited rom' />Limited ROM<br />
              <Radio disabled value='immobile' />Immobile<br />
              <Radio disabled value='flaccid' />Flaccid<br />
              <Radio disabled value='contractured' />Contractured
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Left leg:</SecondaryText><br />
            <RadioGroup field='musculoskeletal.leftLegROM' initialValue={musculoskeletal.leftLegROM}>
              <Radio disabled value='full rom' />Full ROM<br />
              <Radio disabled value='limited rom' />Limited ROM<br />
              <Radio disabled value='immobile' />Immobile<br />
              <Radio disabled value='flaccid' />Flaccid<br />
              <Radio disabled value='contractured' />Contractured
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Right leg:</SecondaryText><br />
            <RadioGroup field='musculoskeletal.rightLegROM' initialValue={musculoskeletal.rightLegROM}>
              <Radio disabled value='full rom' />Full ROM<br />
              <Radio disabled value='limited rom' />Limited ROM<br />
              <Radio disabled value='immobile' />Immobile<br />
              <Radio disabled value='flaccid' />Flaccid<br />
              <Radio disabled value='contractured' />Contractured
            </RadioGroup>
          </div>
          <PrimaryText>Gait/Balance</PrimaryText><br />
          <div className={styles.section}>
            <RadioGroup field='musculoskeletal.gaitBalance' initialValue={musculoskeletal.gaitBalance}>
              <Radio disabled value='steady' />Ambulates on own, steady gait<br />
              <Radio disabled value='unsteady' />Ambulates on own, unsteady gait<br />
              <Radio disabled value='cane' />Ambulates with assistance, cane<br />
              <Radio disabled value='walker' />Ambulates with assistance, walker<br />
              <Radio disabled value='walkerWheelchair' />Walker and wheelchair<br />
              <Radio disabled value='wheelchair' />Wheelchair only<br />
              <Radio disabled value='bedfast' />Bedfast
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>ROM and gait notes:</SecondaryText><br />
            <TextArea disabled field='musculoskeletal.gaitNotes' initialValue={musculoskeletal.gaitNotes} />
          </div>
          <PrimaryText>Amputation</PrimaryText><br />
          <div className={styles.section}>
            <Checkbox disabled field='musculoskeletal.amputee' initialValue={musculoskeletal.amputee} />Amputee
          </div>
          <div className={styles.section}>
            <SecondaryText>Describe amputation:</SecondaryText><br />
            <TextArea disabled field='musculoskeletal.amputationNotes' initialValue={musculoskeletal.amputationNotes} />
          </div>
          <PrimaryText>Postoperative, Orthopedic</PrimaryText><br />
          <div className={styles.section}>
            <Checkbox disabled field='musculoskeletal.postOrthopedic' initialValue={musculoskeletal.postOrthopedic} />Patient is post-orthopedic surgery
          </div>
          <PrimaryText>Post Operative Area</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>Left:</SecondaryText><br />
            <RadioGroup field='musculoskeletal.postOpLeft' initialValue={musculoskeletal.postOpLeft}>
              <Radio disabled value='foot' />Foot<br />
              <Radio disabled value='ankle' />Ankle<br />
              <Radio disabled value='knee' />Knee<br />
              <Radio disabled value='hip' />Hip<br />
              <Radio disabled value='wrist' />Wrist<br />
              <Radio disabled value='elbow' />Elbow<br />
              <Radio disabled value='shoulder' />Shoulder<br />
              <Radio disabled value='femur' />Femur<br />
              <Radio disabled value='humerus' />Humerus<br />
              <Radio disabled value='tibia' />Tibia<br />
              <Radio disabled value='fibula' />Fibula
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Right:</SecondaryText><br />
            <RadioGroup field='musculoskeletal.postOpRight' initialValue={musculoskeletal.postOpRight}>
              <Radio disabled value='foot' />Foot<br />
              <Radio disabled value='ankle' />Ankle<br />
              <Radio disabled value='knee' />Knee<br />
              <Radio disabled value='hip' />Hip<br />
              <Radio disabled value='wrist' />Wrist<br />
              <Radio disabled value='elbow' />Elbow<br />
              <Radio disabled value='shoulder' />Shoulder<br />
              <Radio disabled value='femur' />Femur<br />
              <Radio disabled value='humerus' />Humerus<br />
              <Radio disabled value='tibia' />Tibia<br />
              <Radio disabled value='fibula' />Fibula
            </RadioGroup>
          </div>
          <PrimaryText>Postoperative Extremity Assessment</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>Temperature:</SecondaryText><br />
            <RadioGroup field='musculoskeletal.postOpTemp' initialValue={musculoskeletal.postOpTemp}>
              <Radio disabled value='warm' />Warm to touch<br />
              <Radio disabled value='cool' />Cool to touch
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Color:</SecondaryText><br />
            <RadioGroup field='musculoskeletal.postOpColor' initialValue={musculoskeletal.postOpColor}>
              <Radio disabled value='expected' />Expected color<br />
              <Radio disabled value='cyanotic' />Cyanotic<br />
              <Radio disabled value='mottled' />Mottled<br />
              <Radio disabled value='reddened' />Reddened
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Capillary refill:</SecondaryText><br />
            <RadioGroup field='musculoskeletal.postOpRefill' initialValue={musculoskeletal.postOpRefill}>
              <Radio disabled value='brisk' />Brisk<br />
              <Radio disabled value='sluggish' />Sluggish
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Sensation:</SecondaryText><br />
            <RadioGroup field='musculoskeletal.postOpSense' initialValue={musculoskeletal.postOpSense}>
              <Radio disabled value='sensation' />Sensation to touch intact<br />
              <Radio disabled value='numb' />Numb and tingling to touch<br />
              <Radio disabled value='none' />No sensation to touch
            </RadioGroup>
          </div>
          <PrimaryText>Movement Evaluation of Affected Limb</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>Able to move fingers?</SecondaryText><br />
            <RadioGroup field='musculoskeletal.moveFingers' initialValue={musculoskeletal.moveFingers}>
              <Radio disabled value='yes' />Yes<br />
              <Radio disabled value='no' />No
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Able to move toes?</SecondaryText><br />
            <RadioGroup field='musculoskeletal.moveToes' initialValue={musculoskeletal.moveToes}>
              <Radio disabled value='yes' />Yes<br />
              <Radio disabled value='no' />No
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>General postoperative notes:</SecondaryText><br />
            <TextArea disabled field='musculoskeletal.genPostOpNotes' initialValue={musculoskeletal.genPostOpNotes} />
          </div>
        </div>
      </ContentBox>
    );
  }
}

export default ViewMusculoskeletal;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/view/ViewMusculoskeletal.jsx